import { render, staticRenderFns } from "./tableCallback.vue?vue&type=template&id=7971599a&scoped=true"
import script from "./tableCallback.vue?vue&type=script&lang=js"
export * from "./tableCallback.vue?vue&type=script&lang=js"
import style0 from "./tableCallback.vue?vue&type=style&index=0&id=7971599a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7971599a",
  null
  
)

export default component.exports